/* tslint:disable */
/* eslint-disable */
/**
 * HAU.ITDE.Reach.Portal.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Datum } from '../model';
// @ts-ignore
import type { ProblemDetails } from '../model';
// @ts-ignore
import type { SniApiResponse } from '../model';
// @ts-ignore
import type { ValidationProblemDetails } from '../model';
/**
 * ReachApi - axios parameter creator
 * @export
 */
export const ReachApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return a list of pollutant by sku
         * @param {string} [sku] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ReachGet: async (sku?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/reach`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sku !== undefined) {
                localVarQueryParameter['sku'] = sku;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns Serialnumber Info by given serial number
         * @param {string} serialnumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ReachSerialnumberSerialnumberGet: async (serialnumber: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serialnumber' is not null or undefined
            assertParamExists('v1ReachSerialnumberSerialnumberGet', 'serialnumber', serialnumber)
            const localVarPath = `/v1/reach/serialnumber/{serialnumber}`
                .replace(`{${"serialnumber"}}`, encodeURIComponent(String(serialnumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReachApi - functional programming interface
 * @export
 */
export const ReachApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReachApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Return a list of pollutant by sku
         * @param {string} [sku] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1ReachGet(sku?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Datum>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1ReachGet(sku, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReachApi.v1ReachGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns Serialnumber Info by given serial number
         * @param {string} serialnumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1ReachSerialnumberSerialnumberGet(serialnumber: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SniApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1ReachSerialnumberSerialnumberGet(serialnumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReachApi.v1ReachSerialnumberSerialnumberGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReachApi - factory interface
 * @export
 */
export const ReachApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReachApiFp(configuration)
    return {
        /**
         * 
         * @summary Return a list of pollutant by sku
         * @param {string} [sku] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ReachGet(sku?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Datum>> {
            return localVarFp.v1ReachGet(sku, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns Serialnumber Info by given serial number
         * @param {string} serialnumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ReachSerialnumberSerialnumberGet(serialnumber: string, options?: RawAxiosRequestConfig): AxiosPromise<SniApiResponse> {
            return localVarFp.v1ReachSerialnumberSerialnumberGet(serialnumber, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReachApi - interface
 * @export
 * @interface ReachApi
 */
export interface ReachApiInterface {
    /**
     * 
     * @summary Return a list of pollutant by sku
     * @param {string} [sku] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReachApiInterface
     */
    v1ReachGet(sku?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Datum>>;

    /**
     * 
     * @summary Returns Serialnumber Info by given serial number
     * @param {string} serialnumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReachApiInterface
     */
    v1ReachSerialnumberSerialnumberGet(serialnumber: string, options?: RawAxiosRequestConfig): AxiosPromise<SniApiResponse>;

}

/**
 * ReachApi - object-oriented interface
 * @export
 * @class ReachApi
 * @extends {BaseAPI}
 */
export class ReachApi extends BaseAPI implements ReachApiInterface {
    /**
     * 
     * @summary Return a list of pollutant by sku
     * @param {string} [sku] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReachApi
     */
    public v1ReachGet(sku?: string, options?: RawAxiosRequestConfig) {
        return ReachApiFp(this.configuration).v1ReachGet(sku, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns Serialnumber Info by given serial number
     * @param {string} serialnumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReachApi
     */
    public v1ReachSerialnumberSerialnumberGet(serialnumber: string, options?: RawAxiosRequestConfig) {
        return ReachApiFp(this.configuration).v1ReachSerialnumberSerialnumberGet(serialnumber, options).then((request) => request(this.axios, this.basePath));
    }
}

